import {
  APPLY_PROMO_REQUEST,
  APPLY_PROMO_SUCCESS,
  APPLY_PROMO_FAIL,
  CLEAR_PROMO,
} from "../actions/constants/promo";

const initialState = {
  code: null,
  discount: 0,
  type: null,
  applied: false,
  discountValue: 0,
  validItems: 0,
  total: 0,
  subTotal: 0,
  loading: false,
  error: null,
};

export const promoReducer = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case APPLY_PROMO_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case APPLY_PROMO_SUCCESS:
        console.log(action.payload)
      return {
        ...state,
        loading: false,
        applied: true,
        code: action.payload.code,
        discount: action.payload.discount,
        total: action.payload.total,
        type: action.payload.type,
        subTotal: action.payload.subTotal,
        discountValue: action.payload.discountValue,
        validItems: action.payload.validItems
      };

    case APPLY_PROMO_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CLEAR_PROMO:
      return initialState;

    default:
      return state;
  }
};